import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { cookies, modifyConsentCookie } from '../cookies';
import { tcfApi, CMP_EVENTS, vendors, useTCString } from '../iab-tcf';

const useStyles = makeStyles(theme => ({
  acceptAllButton: {
    padding: theme.spacing(0, 4),
    backgroundColor: theme.palette.primary.main,
    borderRadius: theme.shape.borderRadius,
    transition: 'all 0.2s',
    height: 38,
    color: theme.palette.common.white,
  },
}));
function AcceptAllButton({ setSelectedCookies, setActiveScreen, onClose }) {
  const classes = useStyles();
  const { refreshTCString } = useTCString();

  const acceptAll = () => {
    // cookies
    const updatedCookies = cookies.reduce((acc, cookie) => ({ ...acc, [cookie.value]: true }), {});
    setSelectedCookies(updatedCookies);
    modifyConsentCookie(updatedCookies);

    // tcf
    vendors.acceptAll();
    refreshTCString();
    tcfApi.triggerCmpEvent(CMP_EVENTS.COMPLETE);

    setActiveScreen('customize');
    onClose({ consentGranted: true });
  };

  return (
    <Button
      variant="contained"
      className={classes.acceptAllButton}
      data-test-id="consent-accept-all"
      onClick={acceptAll}
    >
      Accept All
    </Button>
  );
}

AcceptAllButton.propTypes = {
  setSelectedCookies: PropTypes.func.isRequired,
  setActiveScreen: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default AcceptAllButton;
